import React from "react";

const Loader = () => (
  <>
    <div className="lds-circle">
      <div className="lds-ellipsis">
        <div />
        <div />
        <div />
        <div />
      </div>
    </div>
    <div className="loaderOverlay" />
  </>
);

export default Loader;
